import type { Package } from '../api/billing'

export const campaignPrefix = 'TOPUP_PROMO_1324_'
export const isCampaign = (p: Package) => p.code.startsWith(campaignPrefix)
export const isFiveDiscount = (p: Package) => isCampaign(p) && p.priceFen > 0 && p.points === p.priceFen * 2 && p.bonusPoints === 0

// Keep this selection and ordering aligned with RechargePackages in ppnew.
export function storefrontPackages(items: Package[]) {
  const active = items.filter(p => p.active && p.code.startsWith('TOPUP_'))
  const campaign = active.filter(isCampaign)
  return (campaign.length ? campaign : active).sort((a, b) => Number(b.recommended) - Number(a.recommended) || a.sortOrder - b.sortOrder || a.priceFen - b.priceFen || a.id.localeCompare(b.id))
}

export function visibility(p: Package, items: Package[]) {
  if (!p.active) return '不展示（未上架）'
  if (!p.code.startsWith('TOPUP_')) return '用户端不展示'
  return storefrontPackages(items).some(item => item.id === p.id) ? '用户端展示' : '活动期间隐藏'
}

export function discountSummary(p: Package) {
  const base = p.points - p.bonusPoints
  return {
    // Existing campaign retail rate: 1 yuan = 100 points, or 1 fen = 1 point.
    retailFen: p.points,
    effectiveDiscount: p.points > 0 ? p.priceFen / p.points * 10 : 0,
    pointsPerYuan: p.priceFen > 0 ? p.points * 100 / p.priceFen : 0,
    giftSavingYuan: base > 0 ? p.priceFen / 100 * p.bonusPoints / base : 0,
    giftDiscountPercent: p.points > 0 ? p.bonusPoints / p.points * 100 : 0,
  }
}

export function packageValidation(p: Package): string {
  if (typeof p.active !== 'boolean') return '请选择明确的上架状态。'
  if (![p.priceFen, p.points, p.bonusPoints, p.sortOrder].every(Number.isSafeInteger) || p.priceFen < 1 || p.priceFen > 100000000 || p.points < 1 || p.points > 1000000000 || p.bonusPoints < 0 || p.bonusPoints >= p.points || p.sortOrder < 0 || p.sortOrder > 100000) return '金额、积分和排序超出范围，或包含非整数积分。'
  if (p.bonusValidDays !== null && (!Number.isInteger(p.bonusValidDays) || p.bonusValidDays < 1 || p.bonusValidDays > 3650 || !p.bonusPoints)) return '赠送有效期需为 1–3650 天，且必须有赠送积分。'
  if (isCampaign(p) && !isFiveDiscount(p)) return '现有5折活动要求：到账积分 = 金额（分）× 2，赠送积分为 0。请保持与用户端活动文案一致。'
  return ''
}
